/**
 * SiteFooter — universal footer for the marketing site AND the app shell.
 *
 * Kept dependency-light (single Router link + plain <a> to support both
 * SPA nav and hard-refresh flows).
 */
import { Link } from "react-router-dom";

const LINKS = [
    { to: "/guide", label: "Guide d'utilisation", testid: "footer-link-guide" },
    { to: "/cgu", label: "Conditions d'utilisation", testid: "footer-link-cgu" },
    { to: "/confidentialite", label: "Politique de confidentialité", testid: "footer-link-privacy" },
    { to: "/contact", label: "Contact", testid: "footer-link-contact" },
];

/**
 * @param {object} props
 * @param {"paper"|"ink"|"transparent"} [props.tone]
 * @param {boolean} [props.compact]
 */
export default function SiteFooter({ tone = "paper", compact = false }) {
    const bg =
        tone === "ink" ? "bg-ink text-white/85 border-t border-white/10"
            : tone === "transparent" ? "bg-transparent text-inkSoft border-t border-lexiBorder"
                : "bg-paperAlt text-inkSoft border-t border-lexiBorder";
    const linkTone =
        tone === "ink" ? "text-white/85 hover:text-white"
            : "text-inkSoft hover:text-ink";
    const pad = compact ? "py-4" : "py-8";
    return (
        <footer className={`${bg}`} data-testid="site-footer">
            <div className={`max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 ${pad}`}>
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                    <p className="text-[12px]" data-testid="footer-copyright">
                        © 2026 Lexia School. Tous droits réservés.
                    </p>
                    <nav aria-label="Liens légaux" className="flex flex-wrap items-center gap-x-4 gap-y-1 text-[12px]">
                        {LINKS.map((l, i) => (
                            <span key={l.to} className="inline-flex items-center gap-4">
                                <Link
                                    to={l.to}
                                    className={`${linkTone} underline-offset-4 hover:underline`}
                                    data-testid={l.testid}
                                >
                                    {l.label}
                                </Link>
                                {i < LINKS.length - 1 && (
                                    <span aria-hidden="true" className="opacity-40">·</span>
                                )}
                            </span>
                        ))}
                    </nav>
                </div>
            </div>
        </footer>
    );
}
